import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";

export const WalkthroughBackButton = memo(function WalkthroughBackButton({
  stepIndex,
  back,
}: {
  stepIndex: number;
  back(): void;
}) {
  const { t } = useTranslation();
  const isFirst = stepIndex === 0;

  if (isFirst) {
    return null;
  }

  return (
    <RedoButton
      hierarchy="tertiary"
      onClick={back}
      size="sm"
      text={t("Back")}
    />
  );
});

export const WalkthroughNavButtons = memo(function WalkthroughNavButtons({
  stepIndex,
  totalSteps,
  next,
  back,
}: {
  stepIndex: number;
  totalSteps: number;
  next(): void;
  back(): void;
}) {
  const { t } = useTranslation();
  const isLast = stepIndex === totalSteps - 1;

  return (
    <>
      <WalkthroughBackButton back={back} stepIndex={stepIndex} />
      <RedoButton
        hierarchy="primary"
        onClick={next}
        size="sm"
        text={isLast ? t("Done") : t("Next")}
      />
    </>
  );
});
